/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import Styles from '../../css/LoanInformation.module.css';
import tabs from '../../css/LoanInfoTabs.module.css';
import { Button } from '@mui/material';
import ButtonBorderWrapper from '../ButtonBorderWrapper';
import PrivacySettingsModal from '../modals/PrivacySettingsModal';
import EditBorrowerNameModal from '../modals/EditBorrowerNameModal';
import { Tabbed } from '../LoanInfoTabs';
import ButtonBorder from '../ButtonBorder';
import BtnStyles from '../../css/OneTimePaymentPage.module.css';
import { useLoanInformationContext } from '../../contexts/LoanInformationContext';
import { useLoanContext } from '../../contexts/LoanContext';
import LoanHeloc from './LoanHeloc';
import { useSnackbar } from 'notistack';
import { useCallback, useEffect, useState } from 'react';
import BorrowerInfo from './BorrowerInfo';
import EntityInfo from './EntityInfo';
import ContactInfo from './ContactInfo';
import SuccessorInfo from './SuccessorInfo';
import ThirdPartyInfo from './ThirdPartyInfo';
import NextPaymentDueInfo from './NextPaymentDueInfo';
import InvestorDetails from './InvestorDetailsInfo';
import LoanDetails from './LoanDetails';
import LoanServicing from './LoanServicing';
import LoanBalances from './LoanBalances';
import SystemFlags from './SystemFlags';

const ServicerLoanInformation = () => {
  const { loanHeloc } = useLoanContext();
  const {
    handleLoanBorrowersChange,
    privacyModalNumber,
    setPrivacyModalNumber,
    nameModalBorrowerNumber,
    setNameModalBorrowerNumber,
    saveAllData,
    handleCancel,
    hasChanges,
    propData,
    loanData,
  } = useLoanInformationContext();

  const { enqueueSnackbar } = useSnackbar();
  const onClose = useCallback(() => {
    setPrivacyModalNumber('');
  }, []);

  const [showEntityInfo, setShowEntityInfo] = useState(false);
  useEffect(() => {
    setShowEntityInfo(propData?.vestHeldInEntity === true);
  }, [loanData?.loanNumber]);

  return (
    <>
      <ButtonBorderWrapper>
        <PrivacySettingsModal borrowerNumber={privacyModalNumber} open={privacyModalNumber} onClose={onClose} />
        <EditBorrowerNameModal
          borrowerNumber={nameModalBorrowerNumber}
          open={nameModalBorrowerNumber}
          onClose={() => setNameModalBorrowerNumber(undefined)}
          onAfterSave={(bn, { firstName, middleName, lastName, suffix }) => {
            handleLoanBorrowersChange('edit', bn + '.firstName', firstName);
            handleLoanBorrowersChange('edit', bn + '.middleName', middleName);
            handleLoanBorrowersChange('edit', bn + '.lastName', lastName);
            handleLoanBorrowersChange('edit', bn + '.suffix', suffix);
          }}
        />
        <Tabbed.Root
          keepMounted
          selectionMode='multiple'
          initialKeys={['all']}
          requireAtLeastOne
          onLastTabDeselectAttempt={() =>
            enqueueSnackbar('At least one section must remain open', { variant: 'warning' })
          }
          classNames={{
            root: tabs.root,
            tabList: `${tabs.tabList} ${tabs.tabListSticky}`,
            tabButton: tabs.tabBtn,
            tabButtonActive: tabs.tabBtnActive,
            tabPanel: tabs.tabPanel,
          }}
        >
          <Tabbed.Block tabKey='all' label='All'>
            {null}
          </Tabbed.Block>
          <Tabbed.Block tabKey='borrowers' label='Borrower Info'>
            <BorrowerInfo showEntityInfo={showEntityInfo} setShowEntityInfo={setShowEntityInfo} />
          </Tabbed.Block>
          {showEntityInfo && (
            <Tabbed.Block tabKey='entity' label='Entity Info'>
              <EntityInfo></EntityInfo>
            </Tabbed.Block>
          )}
          <Tabbed.Block tabKey='contact' label='Contact Info'>
            <ContactInfo></ContactInfo>
          </Tabbed.Block>
          <Tabbed.Block tabKey='trust' label='Successor in Interest / Trust'>
            <SuccessorInfo></SuccessorInfo>
          </Tabbed.Block>
          <Tabbed.Block tabKey='thirdparty' label='Authorized Third Party'>
            <ThirdPartyInfo></ThirdPartyInfo>
          </Tabbed.Block>
          <Tabbed.Block tabKey='nextpaymentdue' label='Next Payment Due Info'>
            <NextPaymentDueInfo></NextPaymentDueInfo>
          </Tabbed.Block>
          <Tabbed.Block tabKey='investor' label='Investor Details'>
            <InvestorDetails></InvestorDetails>
          </Tabbed.Block>
          <Tabbed.Block tabKey='loandetails' label='Loan Details'>
            <LoanDetails></LoanDetails>
          </Tabbed.Block>
          <Tabbed.Block tabKey='loanservicing' label='Loan Servicing Info'>
            <LoanServicing></LoanServicing>
          </Tabbed.Block>
          <Tabbed.Block tabKey='loanbalances' label='Loan Balances Info'>
            <LoanBalances></LoanBalances>
          </Tabbed.Block>
          {loanHeloc && (
            <Tabbed.Block tabKey='loanheloc' label='HELOC Details'>
              <LoanHeloc></LoanHeloc>
            </Tabbed.Block>
          )}
          <Tabbed.Block tabKey='systemflags' label='System Flags'>
            <SystemFlags></SystemFlags>
          </Tabbed.Block>
        </Tabbed.Root>
        {/* Save and Cancel buttons */}
        <ButtonBorder>
          <Button
            disabled={!hasChanges}
            variant='contained'
            type='button'
            className={BtnStyles.button}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            disabled={!hasChanges}
            variant='contained'
            type='submit'
            className={BtnStyles.button}
            onClick={saveAllData}
          >
            Save
          </Button>
        </ButtonBorder>
      </ButtonBorderWrapper>
    </>
  );
};

export default ServicerLoanInformation;
